import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchAndSortBlogs } from '../utils/blogsHelper';

function Blogs() {
  const [blogs, setBlogs] = useState([]);
  const [filteredBlogs, setFilteredBlogs] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const blogsPerPage = 10;

  useEffect(() => {
    const loadBlogs = async () => {
      try {
        const sortedBlogs = await fetchAndSortBlogs();
        setBlogs(sortedBlogs);
        setFilteredBlogs(sortedBlogs);
      } catch (err) {
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    loadBlogs();
  }, []);

  useEffect(() => {
    const results = blogs.filter(blog =>
      blog.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      blog.tags.some(tag => tag.toLowerCase().includes(searchTerm.toLowerCase()))
    );
    setFilteredBlogs(results);
  }, [searchTerm, blogs]);

  const handleBlogClick = (blog) => {
    const urlTitle = encodeURIComponent(blog.url_title);
    navigate(`/blogs/${urlTitle}`, {
      state: { fileUrl: blog.file_url, title: blog.name }
    });
  };

  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = filteredBlogs.slice(indexOfFirstBlog, indexOfLastBlog);

  const totalPages = Math.ceil(filteredBlogs.length / blogsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className="page-wrapper">
      <div className="blog-container">
        <div className="search-container">
          <div className="search-box">
            <input
              type="text"
              placeholder="Search blogs..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
            {searchTerm && (
              <button
                className="clear-search"
                onClick={() => setSearchTerm('')}
              >
                ×
              </button>
            )}
          </div>
        </div>
        <div className="blog-list">
          {currentBlogs.map((blog) => (
            <div
              key={blog.id}
              className="blog-item"
              onClick={() => handleBlogClick(blog)}
            >
              <h2 style={{ textAlign: 'center', fontFamily: 'Google Sans, sans-serif' }}>{blog.name}</h2>
              {blog.thumbnail && (
                <img src={blog.thumbnail} alt={`${blog.name} thumbnail`} className="blog-thumbnail" />
              )}
              <p className="date" style={{ textAlign: 'center' }}>
                {new Date(blog.created_date).toDateString()}
              </p>
              <div className="tags" style={{ textAlign: 'center' }}>
                <strong>tags:</strong> {blog.tags.join(', ')}
              </div>
            </div>
          ))}
        </div>
        <div className="pagination">
          {Array.from({ length: totalPages }, (_, index) => (
            <button
              key={index + 1}
              onClick={() => handlePageChange(index + 1)}
              className={`pagination-button ${currentPage === index + 1 ? 'active' : ''}`}
            >
              {index + 1}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Blogs;